// Single source of truth for the channel/inbox types offered across the
// app — consumed by the settings inbox-creation list (ChannelList.vue /
// ChannelItem.vue) and the onboarding wizard's channel step
// (ChannelStep.vue). Add new channel types here so both stay in sync.
export const CHANNEL_TYPES = [
  {
    key: 'website',
    iconKey: 'website',
    nameKey: 'INBOX_MGMT.CHANNEL_LIST.WEBSITE',
    subPage: 'website',
    featureFlag: 'channel_website',
  },
  {
    key: 'facebook',
    iconKey: 'facebook',
    name: 'Messenger',
    subPage: 'facebook',
    featureFlag: 'channel_facebook',
    requiresAppConfig: 'fbAppId',
  },
  {
    key: 'instagram',
    iconKey: 'instagram',
    name: 'Instagram',
    subPage: 'instagram',
    featureFlag: 'channel_instagram',
    requiresAppConfig: 'instagramAppId',
  },
  {
    key: 'whatsapp',
    iconKey: 'whatsapp',
    name: 'WhatsApp',
    subPage: 'whatsapp',
    featureFlag: null,
  },
  {
    key: 'email',
    iconKey: 'email',
    nameKey: 'INBOX_MGMT.CHANNEL_LIST.EMAIL',
    subPage: 'email',
    featureFlag: 'channel_email',
  },
  {
    key: 'api',
    iconKey: 'api',
    name: 'API',
    subPage: 'api',
    featureFlag: null,
  },
  {
    key: 'telegram',
    iconKey: 'telegram',
    name: 'Telegram',
    subPage: 'telegram',
    featureFlag: null,
  },
  {
    key: 'line',
    iconKey: 'line',
    name: 'Line',
    subPage: 'line',
    featureFlag: null,
  },
  {
    key: 'lazada',
    iconKey: 'lazada',
    name: 'Lazada',
    subPage: 'lazada',
    featureFlag: null,
    requiresAppConfig: 'lazadaClientId',
  },
];

// Mirrors what ChannelItem.vue's isActive computed used to hardcode —
// single source both settings and onboarding call, so they can't drift
// apart again. window.chatwootConfig is only read here, not baked into
// the static CHANNEL_TYPES data above.
export const isChannelTypeActive = (channelType, accountFeatures = {}) => {
  // Matches the original ChannelItem.vue guard: until the account's
  // features have actually loaded, treat every type as inactive rather
  // than flashing everything as available.
  if (Object.keys(accountFeatures).length === 0) {
    return false;
  }
  if (channelType.featureFlag && !accountFeatures[channelType.featureFlag]) {
    return false;
  }
  if (channelType.requiresAppConfig) {
    return !!window.chatwootConfig?.[channelType.requiresAppConfig];
  }
  return true;
};
